import IndexPage from '../components/pages/IndexPage';

export default IndexPage;
